import { OrganizationTabs } from '@bmsp/bmsp.webcomponent.organization.management';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { IOrganisationState } from '../commonUtils/Redux/Global/globalShared';
import { User } from 'oidc-client';
import i18next from '../../i18next';
import { getFeatureFlagValuebasedOnSIOrg, isFeatureFlagEnabledForUser } from '../commonUtils/LDFlagUtils';


interface OrganizationModalModelProps {
  handlelOrganisationModal: () => void;
  loggedInUser: User | null;
  onAgreementButtonClick: (type: string) => void;
  // isCustomerOrgAccessible: boolean;
}

const OrganizationModal = ({
  handlelOrganisationModal,
  loggedInUser,
  onAgreementButtonClick,
  // isCustomerOrgAccessible
}: OrganizationModalModelProps) => {
  const userProfile = useSelector(
    (state: IOrganisationState) => state.globalShared.userList
  );
  const organisations = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationList
  );
  const orgSelected = useSelector(
    (state: IOrganisationState) =>
      state.globalShared.gatewaySelectedOrganisation ?? ''
  );
  const featureFlags = useFlags();
  const cloudProvider = (window as any).ENV?.CLOUD_PROVIDER ?? '';

  const featureFlagsProps = {
    enableBacsFlow: getFeatureFlagValuebasedOnSIOrg('enableBacsFlow',featureFlags, orgSelected,organisations),
    enablePartnerPortalLogoUpload: featureFlags?.['enablePartnerPortalLogoUpload'],
    enableBacsuiv2: featureFlags?.['enableBacsuiv2'] ?? false,
    enableRename: featureFlags?.['enableRename'] ?? false,
    enableChatbot: isFeatureFlagEnabledForUser('enableChatbotForPartnerPortal', featureFlags, loggedInUser?.profile?.sub)
  };
  const renderIdlePopUp = () => {
    return (
      <OrganizationTabs
        handlelOrganisationModal={handlelOrganisationModal}
        featureFlags={featureFlagsProps}
        onAgreementButtonClick={(type: string) => onAgreementButtonClick(type)}
        selectedSIOrg={orgSelected}
        i18n={i18next as any}
        userProfile={userProfile}
        cloudProvider={cloudProvider}
      />
    );
  };

  return <>{renderIdlePopUp()}</>;
};

export default OrganizationModal;
